export const QUICK_REG = 'utm_quick_reg';
export const UNIK = 'utm_unik';
export const REAL_AGE = 'utm_real_age';
export const NETW = 'utm_netw';
export const CLICKID = 'clickid';
export const TID = 'tid';
export const MSCLKID = 'msclkid';